import { Theme } from '@fluentui/react';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const checkListStyles = (theme: Theme) => ({
  containerRoot: {
    borderRadius: theme.effects.roundedCorner6,
    width: '70%',
    backgroundColor: theme.palette.neutralPrimary,
    boxShadow: theme.effects.elevation8,
  },
  headingContainerRoot: {
    borderBottom: `1px solid ${theme.palette.themeLight}`,
  },
  heading: {
    margin: '10px',
    color: theme.palette.white,
    textAlign: 'center',
  },
  ul: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
    textAlign: 'left',
    cursor: 'pointer',
  },
  li: {
    padding: '8px 12px',
    borderBottom: `1px solid ${theme.palette.themeLight}`,
    color: theme.palette.white,
  },
  inputField: {
    border: 'none',
    color: theme.palette.white,
    ':focus': {
      outline: 'none',
      color: theme.palette.white,
    },
    height: 20,
    fontSize: theme.fonts.medium.fontSize,
    fontFamily: 'inherit',
  },
  checkIcon: {
    margin: '0 10px',
    float: 'right',
    color: theme.palette.neutralLight,
    cursor: 'pointer',
  },
  button: {
    backgroundColor: theme.palette.themePrimary,
    color: theme.palette.neutralPrimary,
    border: 'none',
    borderRadius: `0 0 ${theme.effects.roundedCorner6} ${theme.effects.roundedCorner6}`,
    height: '42px',
    width: '100%',
    ':active': {
      border: 'none',
      backgroundColor: theme.palette.themeDark,
      color: theme.palette.neutralPrimary,
    },
    ':hover': {
      border: 'none',
      backgroundColor: theme.palette.themeDark,
      color: theme.palette.neutralPrimary,
    },
  },
});
